import React, { Fragment, useState } from "react";
import PropTypes from "prop-types";
import Loop from "@material-ui/icons/Loop";
import { Dialog } from "@material-ui/core";
import useSWR from "swr";
import { useIntl } from "react-intl";

import { ActionButton } from "../../../../components";
import PERMISSIONS from "../../../../_common/permissions";
import ModalReiniciarCiclo from "./ModalReiniciarCiclo";
import { createSnackbar } from "../../../../_common";
import { useUsuario } from "../../../../hooks";

const LIMITE_LEADS = 100;

ReiniciarCiclo.propTypes = {
  callback: PropTypes.func,
  claim: PropTypes.oneOfType([PropTypes.bool, PropTypes.number]),
  lead: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    etapa: PropTypes.shape({
      posVenda: PropTypes.bool.isRequired,
      funilId: PropTypes.number,
    }),
  }),
  leads: PropTypes.array,
};

export default function ReiniciarCiclo({ callback = x => x, lead = {}, leads = [], ...props }) {
  const intl = useIntl();
  const [modalOpen, setModalOpen] = useState(false);
  const { featureToggles } = useUsuario();

  const { data: painel, mutate } = useSWR(lead ? `/api/pipeline/lead/painel?id=${lead.id}` : "", {
    fallbackData: lead?.etapa ? lead : undefined,
    revalidateOnMount: !lead?.etapa,
  });

  const abrirModal = () => {
    if (leads.length > LIMITE_LEADS) {
      createSnackbar(intl.formatMessage({ defaultMessage: "Selecione até 100 leads para reiniciar ciclo" }));
      return;
    }

    setModalOpen(true);
  };

  const close = response => {
    if (response && leads.length === 0) mutate(l => ({ ...l, etapa: { ...l.etapa, posVenda: false } }), false);
    setModalOpen(false);
    callback(response);
  };
  const url = "/api/pipeline/etapa/listarPrimeiras";
  const { data: etapas } = useSWR(() => url);

  if ((!painel && leads.length === 0) || (!featureToggles.rolloutReniciarCicloEmMassa && leads.length >= 1))
    return null;

  return (
    <Fragment>
      <ActionButton
        id="btn-reiniciar-ciclo"
        type="menu"
        onClick={abrirModal}
        icon={<Loop />}
        label={intl.formatMessage({ defaultMessage: "Reiniciar ciclo" })}
        tooltip={intl.formatMessage({
          defaultMessage: "Iniciar novo ciclo e enviar lead para primeira etapa do funil",
        })}
        leads={lead ?? leads}
        claim={PERMISSIONS.REINICIAR_CICLO}
        {...props}
      />
      <Dialog disableBackdropClick open={modalOpen} onClose={() => close(false)}>
        <ModalReiniciarCiclo
          id={lead?.id}
          leads={leads}
          funilId={lead?.etapa?.funilId}
          etapas={etapas}
          {...props}
          callback={close}
        />
      </Dialog>
    </Fragment>
  );
}
